<template>
	<div>
		<div class="content-header">
			<ol class="breadcrumb">
				<li class="active">分类管理</li>
			</ol>
		</div>
		<div class="content-operator content-border">
			<el-button type="primary" size="small" @click="$common.goRouterLink({ name: 'goodsTypeDetail', query: { level: 1 } })">添加一级分类</el-button>
			<el-button type="primary" size="small" @click="$common.goRouterLink({ name: 'goodsTypeDetail', query: { level: 2 } })">添加二级分类</el-button>
		</div>
		<div class="content-query content-border">
			<el-form :inline="true" :model="query" class="demo-form-inline">
				<el-form-item label="类型级别：">
					<el-select clearable v-model="query.level"><el-option v-for="item in levels" :key="item.name" :label="item.label" :value="item.name"></el-option></el-select>
				</el-form-item>
				<el-form-item><el-button class="btn btn-primary" type="primary" size="small" icon="el-icon-search" @click="submitQuery(1)">搜索</el-button></el-form-item>
			</el-form>
		</div>
		<hr />
		<div class="title"><span>分类列表</span></div>
		<div class="content-data" v-if="goodsTypes && 0 < goodsTypes.length">
			<el-table :data="goodsTypes" style="width: 100%;margin-bottom: 20px;"
				row-key="id" border  :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="date" label="层级" sortable width="180"> </el-table-column>
				<el-table-column align="center" label="图片">
					<template slot-scope="scope">
						<el-image style="height: 100px; width: 100px;" :src="dynamicPath + scope.row.iconPath">
							<div slot="error" class="image-slot"><el-image title="加载失败" src="https://szdbi.oss-cn-shenzhen.aliyuncs.com/%E5%9B%BE%E7%89%87.png" /></div>
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="name" label="名称" width="180"></el-table-column>
				<el-table-column align="center" label="级别" prop="level" />
				<el-table-column align="center" label="位置" prop="sequence" />
        <el-table-column align="center" label="开放状态" prop="enable">
          <template slot-scope="scope">
            <el-switch
                @change="saveEnable({goodsType:scope.row})"
                v-model="scope.row.enable"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                active-text="开放"
                inactive-text="禁用"
            >
            </el-switch>
          </template>
        </el-table-column>
				<el-table-column align="center" fixed="right" label="操作" width="600px">
					<template slot-scope="scope">
						<p>
							<el-button @click="saveSequence(scope.row, -1)" type="primary" size="mini" round>上移</el-button>
							<el-button @click="saveSequence(scope.row, 1)" type="primary" size="mini" round>下移</el-button>
							<el-button v-if="scope.row.level === 1" @click="saveSequence(scope.row, -2)" type="primary" size="mini" round>置顶</el-button>
							<el-button v-if="scope.row.level === 1" @click="saveSequence(scope.row,2)" type="primary" size="mini" round>置底</el-button>
						</p>
						<p>
							<el-button type="primary" size="mini" round @click="$common.goRouterLink({ name: 'goodsTypeDetail', query: { goodsTypeId: scope.row.id } })">
								修改
							</el-button>
							<el-button type="primary" size="mini" round
								v-if="scope.row.level === 1" @click="$common.goRouterLink({ name: 'goodsTypeDetail', query: { level: 2, parentTypeId: scope.row.id } })">
								添加二级分类
							</el-button>
							<el-button @click="deleteGoodsType(scope.row.id)" type="danger" size="mini" round>删除</el-button>
						</p>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="content-data" v-else>没有查询到数据</div>
		<vue-pager v-bind:datafile="fillData" url="goodsType/pageGoodsTypeByManager" v-bind:query="query" ref="pager" v-bind:init="true"></vue-pager>
	</div>
</template>
<script>
export default {
	data() {
		return {
			query: {
				level:1
			},
			goodsTypes: [],
			goodsTypeMap:{},
			levels: [{ label: '一级', name: 1 }],
			dynamicPath: config.dynamicResourcePath
		};
	},
	created() {
		let _this = this;
		_this.pageGoodsTypeByTwos();
	},
	methods: {
    saveEnable(e) {
      let _this = this;
      _this.$common.my_ajax({
        url: 'goodsType/saveGoodsType',
        data: e.goodsType,
        success: function () {
          this.submitQuery(this.query.current)
        }
      });
      console.log(e);
    },
		load(tree, treeNode, resolve) {
			var _this=this;
			_this.pageGoodsTypeByParentTypeId(tree.id,tree.index,function(_goodsType){
				if(_goodsType){
					resolve(_goodsType)
				}
			})
		},
		pageGoodsTypeByParentTypeId(_parentTypeId,_index,_check) {
			let _this = this;
			_this.$common.ajaxRequest({
				url: 'goodsType/pageGoodsTypeByManager',
				data: { parentTypeId: _parentTypeId ,limit:-1},
				repeatKey: Math.random(),
				success: res => {
					var _item = res.items || [];
					for(var i in _item){
						_item[i].index=_index
					}
					_check(_item);
				}
			});
		},
		pageGoodsTypeByTwos() {
			let _this = this;
			_this.$common.ajaxRequest({
				url: 'goodsType/pageGoodsTypeByManager',
				data: { level: 2 ,limit:-1},
				repeatKey: Math.random(),
				success: res => {
					var _item = res.items || [];
					var _temp={};
					for(var i in _item){
						var temp=_temp[_item[i].parentTypeId];
						if(!temp){
							_temp[_item[i].parentTypeId]=[]
						}
						_temp[_item[i].parentTypeId].push(_item[i]);
					}
					_this.goodsTypeMap=_temp;
				}
			});
		},
		fillData(_response) {
			let _this = this;
			let _item=_response.items;
			for(var i in _item){
				//_item[i].hasChildren=true;
				_item[i].index=i;
				var _children=_this.goodsTypeMap[_item[i].id];
				for(var j in _children){
					_children[j].index=i;
				}
				_item[i].children=_children;
			}
			_this.goodsTypes =_item;
		},
		submitQuery(_num) {
			this.goodsTypes=[],
			this.$refs.pager.gotoPage(_num);
		},
		saveSequence(_goodsType, _direction) {
			let _this = this;
			var _goodsTypeId=_goodsType.id;
			_this.$common.ajaxRequest({
				url: 'goodsType/saveSequence',
				data: {
					goodsTypeId: _goodsTypeId,
					direction: _direction
				},
				success: res => {
					if(1==_goodsType.level){
						_this.submitQuery(1);
					}else{
						_this.pageGoodsTypeByParentTypeId(_goodsType.parentTypeId,_goodsType.index,function(_item){
							if(_item){
								var _index=_goodsType.index*1;
								_this.goodsTypes[_index].children=_item
							}
						})
					}
				}
			});
		},
		deleteGoodsType(_goodsTypeId) {
			let _this = this;
			_this.$confirm('是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				_this.$common.ajaxRequest({
					url: '/goodsType/deleteGoodsType',
					data: { goodsTypeId: _goodsTypeId },
					success(response) {
						_this.$message({
							type: 'success',
							message: '删除成功'
						});
						_this.submitQuery(1);
					}
				});
			}).catch(() => {
				this.$message({
					message: '取消删除',
					type: 'warning'
				});
			});
		}
	}
};
</script>
